"use strict";

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var address_1 = require("./address");

var class_transformer_1 = require("class-transformer");

var pagination_1 = require("./pagination");

var queryDecorator_1 = require("../queryDecorator");

var ArchitectClientFilterDTO = function ArchitectClientFilterDTO() {
  _classCallCheck(this, ArchitectClientFilterDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectClientFilterDTO.prototype, "query", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ArchitectClientFilterDTO.prototype, "architectIds", void 0);

exports.ArchitectClientFilterDTO = ArchitectClientFilterDTO;

var ArchitectClientDTO = function ArchitectClientDTO() {
  _classCallCheck(this, ArchitectClientDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ArchitectClientDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsDefined(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectClientDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsEmail(), __metadata("design:type", String)], ArchitectClientDTO.prototype, "email", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectClientDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], ArchitectClientDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectClientDTO.prototype, "createdAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectClientDTO.prototype, "updatedAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectClientDTO.prototype, "deletedAt", void 0);

exports.ArchitectClientDTO = ArchitectClientDTO;

var ArchitectClientSuggestionDTO = function ArchitectClientSuggestionDTO() {
  _classCallCheck(this, ArchitectClientSuggestionDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ArchitectClientSuggestionDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsDefined(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectClientSuggestionDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsEmail(), __metadata("design:type", String)], ArchitectClientSuggestionDTO.prototype, "email", void 0);

exports.ArchitectClientSuggestionDTO = ArchitectClientSuggestionDTO;

var ArchitectClientPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(ArchitectClientPaginationResponse, _pagination_1$Paginat);

  function ArchitectClientPaginationResponse() {
    _classCallCheck(this, ArchitectClientPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectClientPaginationResponse).apply(this, arguments));
  }

  return ArchitectClientPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([pagination_1.PaginationData(ArchitectClientDTO), __metadata("design:type", Array)], ArchitectClientPaginationResponse.prototype, "data", void 0);

exports.ArchitectClientPaginationResponse = ArchitectClientPaginationResponse;

var ArchitectClientCreationWithoutArchitectDTO = function ArchitectClientCreationWithoutArchitectDTO() {
  _classCallCheck(this, ArchitectClientCreationWithoutArchitectDTO);
};

__decorate([class_validator_1.IsDefined(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectClientCreationWithoutArchitectDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsEmail(), __metadata("design:type", String)], ArchitectClientCreationWithoutArchitectDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectClientCreationWithoutArchitectDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], ArchitectClientCreationWithoutArchitectDTO.prototype, "phone", void 0);

exports.ArchitectClientCreationWithoutArchitectDTO = ArchitectClientCreationWithoutArchitectDTO;

var ArchitectClientCreationDTO =
/*#__PURE__*/
function (_ArchitectClientCreat) {
  _inherits(ArchitectClientCreationDTO, _ArchitectClientCreat);

  function ArchitectClientCreationDTO() {
    _classCallCheck(this, ArchitectClientCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectClientCreationDTO).apply(this, arguments));
  }

  return ArchitectClientCreationDTO;
}(ArchitectClientCreationWithoutArchitectDTO);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ArchitectClientCreationDTO.prototype, "architectId", void 0);

exports.ArchitectClientCreationDTO = ArchitectClientCreationDTO;

var ArchitectClientUpdateDTO = function ArchitectClientUpdateDTO() {
  _classCallCheck(this, ArchitectClientUpdateDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDefined(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectClientUpdateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsEmail(), __metadata("design:type", String)], ArchitectClientUpdateDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectClientUpdateDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], ArchitectClientUpdateDTO.prototype, "phone", void 0);

exports.ArchitectClientUpdateDTO = ArchitectClientUpdateDTO;